/** @file ikConjugate: the inverse of a unit quaternion (private stand-in for math M1 quatConjugate). */
import type { Quat } from '@zilo/pose3d-math/quat/quat';

/** `[-x, -y, -z, w]`. */
export function ikConjugate(q: Quat): Quat {
  return [-q[0], -q[1], -q[2], q[3]];
}
